// extracted by mini-css-extract-plugin
export default {"title":"SignUpVk_title__9a7us","modalBody":"SignUpVk_modalBody__fHD8d","modalMessage":"SignUpVk_modalMessage__EJzva","card":"SignUpVk_card__Kpdoc"};